import { render, staticRenderFns } from "./AlertWizard.vue?vue&type=template&id=14bfb7e8"
import script from "./AlertWizard.vue?vue&type=script&lang=js"
export * from "./AlertWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports